import {initialActions, initialMutations, initialState} from "./common_store";
import {VERSIONED_API_URL} from "../../config/config";
import Http from "axios";

let iniState = {
    url_name: 'non-visa-certifications',
    type: null,
    tippani_content: '',
    tippaniGenerated: false,
    certificationData: {
        traveller: {}
    },
};

iniState = {...initialState, ...iniState};

const getters = {
    reportLoading: state => state.loading,
};

const scopeActions = {
    async getDetails({state, commit}, submission_no) {
        const response = await Http.get(`${VERSIONED_API_URL}/${state.url_name}/${state.type}/${submission_no}`);
        commit('setCertificationData', response.data.data)
    },
    async saveTippani({state, commit}, content) {
        const submission_no = state.certificationData.submission_no;
        try {
            const response = await Http.post(`${VERSIONED_API_URL}/${state.url_name}/tippani/${submission_no}`, {content});
            commit('setTippaniGenerated');
            return response;
        } catch (e) {
            throw e;

        }
    },
    async approveCertification({state, dispatch}, data) {
        const submission_no = state.certificationData.submission_no;
        try {
            const response = await Http.post(`${VERSIONED_API_URL}/${state.url_name}/approve/${submission_no}`, data);
            dispatch('getDetails', state.certificationData.submission_no);
            return response;
        } catch (e) {
            throw e;
        }
    },
    async rejectCertification({state, dispatch}, data) {
        const submission_no = state.certificationData.submission_no;
        try {
            const response = await Http.post(`${VERSIONED_API_URL}/${state.url_name}/reject/${submission_no}`, data);
            dispatch('getDetails', state.certificationData.submission_no);
            return response;
        } catch (e) {
            throw e;
        }
    },
    async generateVoucher({state, commit}) {
        try {
            const response = await Http.post(`${VERSIONED_API_URL}/${state.url_name}/voucher/` + state.certificationData.submission_no);
            commit('setVoucherData', response.data);
            return true;
        } catch (e) {
            throw  e;
        }
    },
    async checkPaymentStatus({state, dispatch}) {
        try {
            const response = await Http.post(`${VERSIONED_API_URL}/${state.url_name}/payment-status/` + state.certificationData.submission_no);
            dispatch('getDetails', state.certificationData.submission_no);
            return true;
        } catch (e) {
            throw  e;
        }
    },
    async verifyCertification({state, dispatch}) {
        const submission_no = state.certificationData.submission_no;
        try {
            const response = await Http.post(`${VERSIONED_API_URL}/${state.url_name}/verify/${submission_no}`);
            dispatch('getDetails', state.certificationData.submission_no);
            return response;
        } catch (e) {
            throw e;
        }
    },
};

const actions = {...initialActions, ...scopeActions};

const scopeMutation = {
    setType(state, type) {
        state.type = type;
    },
    setCertificationData(state, certificationData) {
        state.certificationData = certificationData;
    },
    setTippaniContent(state, tippani_content) {
        state.tippani_content = tippani_content;
    },
    setTippaniGenerated(state) {
        state.certificationData.tippani_generated = true;
    },
    setVoucherData(state, data) {
        state.certificationData = {
            ...state.certificationData, ...{
                malanika_active: data.malanika_active,
                voucher_number: data.voucher_number,
                voucher_generated: true
            }
        };
    }
};


const mutations = {...initialMutations, ...scopeMutation};

export default {
    namespaced: true,
    state: iniState,
    getters,
    actions,
    mutations
}
